import React from 'react'

import noop from 'lodash/noop'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  name?: string
  disabled?: boolean
  horizontal?: boolean
  emphasized?: boolean
  block?: boolean
  value?: string
  onChange?: (
    value: string,
    name: string | undefined,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
}

const RadioGroupField = ({
  classNames,
  children,
  value,
  name,
  disabled = false,
  block = false,
  horizontal = false,
  emphasized = false,
  onChange = noop,
}: Props) => {
  const actualName = useUniqueId(name)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value, actualName, event)
  }

  return (
    <div className={cn('RadioGroupField', {horizontal, block}, classNames)}>
      {mapChildrenWithFragments(
        children,
        child =>
          child &&
          React.cloneElement(child, {
            onChange: handleChange,
            name: actualName,
            checked: value === child.props.value,
            emphasized,
            disabled: child.props.disabled || disabled,
          })
      )}
    </div>
  )
}

export default RadioGroupField
